import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

export default function headerScroll() {
    gsap.registerPlugin(ScrollTrigger);
    const showAnim = gsap
        .from('header', {
            yPercent: -200,
            paused: true,
            duration: 0.2,
        })
        .progress(1);

    ScrollTrigger.create({
        start: 'top top',
        end: 'max',
        onUpdate: (self) => {
            self.direction === -1 ? showAnim.play() : showAnim.reverse();
        },
    });
}
